import { ListboxPopover as ListboxPopover$1 } from '@reach/listbox';
import PropTypes from 'prop-types';
import { ROOT_CLASSNAMES } from '../../constants/globals.js';
import { createComponent } from '../core/create-component.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
const propTypes = {
  inModal: PropTypes.bool
};
const ListboxPopover = createComponent({
  displayName: 'ListboxPopover',
  root: ListboxPopover$1,
  propTypes,
  propConfig: {
    processProps(props) {
      return _objectSpread({
        lightMode: !props.darkMode
      }, props);
    },
    classNames(props) {
      const classes = [ROOT_CLASSNAMES.base, 'swan-listbox-popover'];
      if (props.inModal) classes.push('swan-listbox-popover-in-modal');
      return classes;
    }
  }
});
export { ListboxPopover };